module.exports = __webpack_public_path__ + "static/media/level-4-anim.c6259ce8.gif";